<div class="view-container">
  <mat-card class="company-list-container">
    <div class="company-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>{{ showDistributorColumns ? 'local_shipping' : 'business' }}</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">{{ showDistributorColumns ? 'Distributors' : 'Companies' }}</h1>
      </div>

      <form class="company-list__filters" [formGroup]="companyFilterForm">
        <mat-form-field appearance="outline" class="company-list__filter company-list__filter--search" subscriptSizing="dynamic">
          <input type="text" formControlName="search" matInput placeholder="Search companies" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="company-list__filter company-list__filter--type" subscriptSizing="dynamic">
          <mat-label>Company type</mat-label>
          <mat-select formControlName="companyType">
            <mat-option [value]="allCompanyTypes">All</mat-option>
            @for (type of companyTypes; track type) {
              <mat-option [value]="type.code">
                {{ type.type }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="company-list__filter company-list__filter--status" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select formControlName="activeStatus">
            @for (opt of activeStatusOptions; track opt.value) {
              <mat-option [value]="opt.value">
                {{ opt.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>

    <mat-paginator
      class="company-list__paginator"
      [pageSizeOptions]="[10, 15, 20]"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [length]="totalNumberOfCompanies"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of companies"
    >
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table
        mat-table
        [dataSource]="companiesDataSource"
        matSort
        (matSortChange)="sortCompanies($event)"
        class="mbp-data-table company-list"
      >
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by Name"
            start="desc"
            class="name-col"
          >
            Name
          </th>
          <td mat-cell *matCellDef="let company" class="name-col">{{ company.name }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let company">{{ getType(company) }}</td>
        </ng-container>

        @if (showDistributorColumns) {
          <ng-container matColumnDef="invoice_mode">
            <th mat-header-cell *matHeaderCellDef>Invoice mode</th>
            <td mat-cell *matCellDef="let company">{{ rowInvoiceMode(company) }}</td>
          </ng-container>
        }

        @if (showDistributorColumns) {
          <ng-container matColumnDef="weekly_invoice_day">
            <th mat-header-cell *matHeaderCellDef>Weekly day</th>
            <td mat-cell *matCellDef="let company">{{ rowWeeklyDay(company) }}</td>
          </ng-container>
        }

        <ng-container matColumnDef="is_active">
          <th mat-header-cell *matHeaderCellDef>Active</th>
          <td mat-cell *matCellDef="let company">{{ rowActive(company) }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let company">
            {{ company.email ? company.email : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="phone_number">
          <th mat-header-cell *matHeaderCellDef>Phone number</th>
          <td mat-cell *matCellDef="let company">
            {{ company.phone_number ? company.phone_number : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="sage">
          <th mat-header-cell *matHeaderCellDef>Sage</th>
          <td mat-cell *matCellDef="let company">
            @if (isOnSage(company)) {
              <span class="company-list__sage company-list__sage--synced">On Sage</span>
            } @else {
              <span class="company-list__sage">Not on Sage</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let company">
            {{ formatTime(company.created_at) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let company">
            {{ formatTime(company.updated_at) }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr
          mat-row
          (click)="openCompany(row)"
          *matRowDef="let row; columns: tableColumns"
        ></tr>
      </table>
    </div>
  </mat-card>
</div>
